import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormFieldModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from "@progress/kendo-angular-inputs";

import { QueryPanelConnectorService } from 'src/app/modules/fwcore/services';

@Component({
  selector: 'criteria-container',
  styleUrls: ['./criteria-container.component.scss'],
  templateUrl: './criteria-container.component.html',
  standalone: true,
  imports: [
    FormFieldModule, FormsModule, InputsModule, LabelModule, ReactiveFormsModule]
})

export class CriteriaContainerComponent
  implements OnInit {
  /*-------------------------- Input / Outputs --------------------------------*/

  @Output() onChange = new EventEmitter();

  /*-------------------------- public properties / methods --------------------*/

  /*-------------------------- public methods ------------------------*/

  public treeviewContainerForm: FormGroup = new FormGroup({
    filterBox: new FormControl()
  });

  /*-------------------------- Internal properties  ------------------*/

  protected filterValue: string = "";
  protected interval: any;
  protected isFilterFocus: boolean = false;

  /*-------------------------- Constructor  --------------------------*/
  constructor (protected connectorService: QueryPanelConnectorService) {}

  /*-------------------------- ng --------------------------*/
  ngOnInit(): void {
  }

  /*-------------------------- Event handlers --------------------------*/

  onFilterChange(value: string) {
    this.filterValue = value;
  }

  onFilterInputBlur() {
    this.isFilterFocus = false;
  }

  onFilterInputFocus() {
    this.isFilterFocus = true;
  }

  /*-------------------------- Host listeners --------------------------*/

  // Keyboard event: handles the "press enter to search" because Telerik
  // doesn't give us a keypress event for the kendoTextBox.
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.isFilterFocus && event.key == "Enter") {
      this.connectorService.filter(this.filterValue);
    }
  }
}
